import { Form } from 'antd'

import CardTypeSelect from '../CardTypeSelect'


const CardTypeSelectField = ({ name, label, required, disabled, filter, onChange }) => {
  return (
    <Form.Item label={label} name={name} rules={[{ required: required }]}>
      <CardTypeSelect allowClear={!required} required={required} disabled={disabled} filter={filter} onChange={onChange} />
    </Form.Item>
  );
}

CardTypeSelectField.getValue = (values) => {
  return values;
}

CardTypeSelectField.getDisplayValue = (values, config) => {
  return values
};

export default CardTypeSelectField
